import { Component, OnInit, NgZone, OnDestroy, AfterViewInit} from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { AuthenticationService } from '../../authentication.service';
import { ModalService } from '../../services/modals.service';
import { GoogleAnalyticsService } from '../../services/google-analytics.service';
import { closeModal} from '../../shared/modal-functions';
import { homeView } from './home.static.data';
import { alerts, alertsModals } from './alerts-notifications';
import { SubscriptionService } from '../../services/subscription.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['../../app.component.css']
})
export class HomeComponent implements OnInit, AfterViewInit, OnDestroy {
  // Static data
  homeView: any;
  alertsView: any;
  alertsModalsView: any;
  // Authentication
  isLoggedin: boolean;
  isLoggedInSubscription: Subscription;
  // Control view
  closeModal: any;
  // User data
  welcomeMessage: string;

  constructor(private router: Router, public zone: NgZone, public authenticationService: AuthenticationService, public subscriptionService: SubscriptionService, public modalService: ModalService, public googleAnalyticsService: GoogleAnalyticsService) {
    this.homeView = homeView;
    this.alertsView = alerts;
    this.alertsModalsView = alertsModals;
    this.closeModal = closeModal;
  }

  ngOnInit() {
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.constructHome();
    });
  }

  ngOnDestroy(): void {
    if (this.isLoggedInSubscription) {
      this.isLoggedInSubscription.unsubscribe();      
    }
  }

  /*
    * Check if user has been authenticated to render welcome message.
  */
  constructHome() {
    this.isLoggedInSubscription = this.authenticationService.getIsAuthenticated().subscribe((IsAuthenticated) => {
      this.zone.run(() => {
        if (IsAuthenticated && !this.authenticationService.isTokenExpired()) {
          this.isLoggedin = IsAuthenticated;
          this.renderPersonalizedWelcomeMessage();
        } else {
          this.renderDefaultWelcomeMessage();
        }
        if (IsAuthenticated && this.authenticationService.isTokenExpired()) this.authenticationService.logoutUserExpiredSession();
      });
    });
  }

  renderPersonalizedWelcomeMessage() {
    if (this.authenticationService.userProfile && this.authenticationService.userProfile.gender === 'f') {
      this.welcomeMessage = '¡Hola ' + this.authenticationService.userProfile.firstName + '! Bienvenida al portal del manejo de tu ';
    } else if (this.authenticationService.userProfile && this.authenticationService.userProfile.gender === 'm') {
      this.welcomeMessage = '¡Hola ' + this.authenticationService.userProfile.firstName + '! Bienvenido al portal del manejo de tu ';
    } else if (!this.authenticationService.userProfile || this.authenticationService.userProfile.gender === 'u' || !this.authenticationService.userProfile.gender) {
      this.renderDefaultWelcomeMessage();
    }
  }

  renderDefaultWelcomeMessage() {
    this.welcomeMessage = 'Bienvenido al portal del manejo de tu ';
  }

  submitGAEvent(eventCategory, eventAction, eventLabel) {
    this.googleAnalyticsService.emitEvent(eventCategory, eventAction, eventLabel, null);
  }

}



// WEBPACK FOOTER //
// /codebuild/output/src4156872633/src/src/app/components/home/home.component.ts